// helpers/network-handler.js
import { Network } from '@capacitor/network'

class NetworkHandler {
    constructor() {
        this.isOnline = true
        this.pendingRequests = []
        this.listeners = []
        this.init()
    }

    async init() {
        const status = await Network.getStatus()

        this.isOnline = status.connected

        Network.addListener('networkStatusChange', (status) => {
            const wasOffline = !this.isOnline

            this.isOnline = status.connected

            if (this.isOnline && wasOffline) {
                this.retryPendingRequests()
            }

            this.notifyListeners(this.isOnline)
        })
    }

    async checkConnection() {
        const status = await Network.getStatus()

        this.isOnline = status.connected

        return this.isOnline
    }

    addRequest(requestFn) {
        return new Promise((resolve, reject) => {
            this.pendingRequests.push({ requestFn, resolve, reject })
        })
    }

    async retryPendingRequests() {
        const requests = [...this.pendingRequests]

        this.pendingRequests = []

        // Групуємо однакові запити (за URL і методом)
        const uniqueRequests = new Map()

        for (const request of requests) {
            const key = `${request.requestFn.toString()}`

            if (!uniqueRequests.has(key)) {
                uniqueRequests.set(key, [request])
            } else {
                uniqueRequests.get(key).push(request)
            }
        }

        // Виконуємо унікальні запити
        for (const [, requestGroup] of uniqueRequests) {
            const firstRequest = requestGroup[0]

            try {
                const result = await firstRequest.requestFn()

                // Резолвимо всі однакові запити з одним результатом
                requestGroup.forEach(({ resolve }) => resolve(result))
            } catch (error) {
                // Реджектимо всі однакові запити з одною помилкою
                requestGroup.forEach(({ reject }) => reject(error))
            }
        }
    }

    addListener(callback) {
        this.listeners.push(callback)
    }

    removeListener(callback) {
        this.listeners = this.listeners.filter((cb) => cb !== callback)
    }

    notifyListeners(isOnline) {
        this.listeners.forEach((callback) => callback(isOnline))
    }

    clearPendingRequests() {
        this.pendingRequests = []
    }
}

export const networkHandler = new NetworkHandler()
